
export default function LocationMarker({ text = "Meeting point" }) {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transform: "translate(-50%, 0)", // center horizontally
      }}
    >
      {/* Circle Marker */}
      <div
        style={{
          width: "32px",
          height: "32px",
          backgroundColor: "#000000",
          borderRadius: "50%",
          border: "2px solid white",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          position: "relative",
          marginBottom: "-16px", // aligns bottom of circle with coordinate
        }}
      >
        <div
          style={{
            width: "8px",
            height: "8px",
            backgroundColor: "white",
            borderRadius: "50%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>

      {/* Optional label below marker */}
      {text && (
        <div
          style={{
            marginTop: "6px",
            backgroundColor: "white",
            padding: "3px 8px",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            fontSize: "13px",
            fontWeight: "500",
            color: "#222",
            fontFamily: "Inter, sans-serif",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
}
